import { Component, Input, ViewChild, ViewChildren, QueryList, Output, EventEmitter, AfterViewInit, ChangeDetectionStrategy }  from '@angular/core';
import { NgForm, FormBuilder, FormGroup, FormControl }     from '@angular/forms';
import { Category, PriceLevel, TicketFee } from '../../models';
import { LeoBox, ControlMessages, PriceForm } from "../../ui-helper"
import { DisplayCategory } from "../../models/ui";
import { DragulaService } from 'ng2-dragula';

@Component({
	selector: 'category-form',
	templateUrl: "./category-form.html",
	providers: [ DragulaService ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./category-form.scss")]
})

export class CategoryForm implements AfterViewInit {
	private _displayCategory;
	private lastEmittedDisplayCategory;

	@Input() protected set displayCategory(dc: DisplayCategory) {
		this._displayCategory = dc;
		this.lastEmittedDisplayCategory = Object.assign({}, dc);
		(<FormControl>this.formGroup.controls["vat"]).setValue(this.displayCategory.category.vat);
		(<FormControl>this.formGroup.controls["name"]).setValue(this.displayCategory.category.name);
		(<FormControl>this.formGroup.controls["type"]).setValue(this.displayCategory.category.type);
		(<FormControl>this.formGroup.controls["color"]).setValue(this.displayCategory.category.color);
	}
	@Input() showFees: boolean;
	@Input() hasMerchantMarketingRole: boolean;
	protected get displayCategory() {
		return this._displayCategory;
	}

	@Output() public displayCategoryChange = new EventEmitter<DisplayCategory>();
	@Output() public addReducedPriceClicked = new EventEmitter<void>();
	@Output() public deleteCategoryClicked = new EventEmitter<void>();
	@Output() public deletePriceLevelClicked = new EventEmitter<PriceLevel>();

	@ViewChild("form") private ngForm: NgForm;
	@ViewChildren(PriceForm)
	priceForms: QueryList<PriceForm>;

	protected formGroup: FormGroup;

	constructor(fb: FormBuilder, private dragulaService: DragulaService) {
		this.formGroup = fb.group({
			"vat": "",
			"name": "",
			"type": "",
			"color": ""
		})

		this.dragulaService.createGroup("REDUCED_PRICELEVELS", {
			moves: (el, container, handle) => {
				return handle.className === 'pricelevel__icon-container--move' || handle.className === 'pricelevel__sort-icon';
			},
		});
	}

	public ngAfterViewInit() {
		this.ngForm.form.valueChanges.debounceTime(400).subscribe(newVal => {
			const newCat = Object.assign({}, this.lastEmittedDisplayCategory.category, {
				name: newVal["name"],
				type: newVal["type"],
				vat: parseFloat(newVal["vat"]),
				color: newVal["color"]
			})
			const newDC = Object.assign({}, this.lastEmittedDisplayCategory, { category: newCat })
			this.lastEmittedDisplayCategory = newDC;
			this.displayCategoryChange.emit(
				newDC
			);
		})
	}

	public isValid(): boolean {
		return this.formGroup.valid && this.priceForms.map(pf => pf.isValid()).reduce((a, b) => a && b);
	}

	protected reducedPriceLevelChange(index: number, pl: PriceLevel) {
		const newReducedPrices = this.lastEmittedDisplayCategory.combinedPriceLevel.reduced.map((entry, listIndex) => index !== listIndex ? entry : pl);
		const newCombinedPriceLevel = Object.assign({}, this.lastEmittedDisplayCategory.combinedPriceLevel, {
			reduced: newReducedPrices
		})
		const newDC = Object.assign({}, this.lastEmittedDisplayCategory, { combinedPriceLevel: newCombinedPriceLevel })
		this.lastEmittedDisplayCategory = newDC;
		this.displayCategoryChange.emit(newDC);
	}

	protected standardPriceLevelChange(pl: PriceLevel) {
		const newCombinedPriceLevel = Object.assign({}, this.displayCategory.combinedPriceLevel, {
			standard: pl
		})
		const newDC = Object.assign({}, this.lastEmittedDisplayCategory, { combinedPriceLevel: newCombinedPriceLevel });
		this.lastEmittedDisplayCategory = newDC;
		this.displayCategoryChange.emit(newDC);
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/category-form/category-form.component.ts